import { DecimalRuleDescription, truncateDecimal } from '@ui-lib/components';

const POSTFIX = 'Sol/s';
const UNITS = ['K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'] as const;

export interface ISolHashrateValue {
  hashRate: number | string;
  literal: string;
}

/**
 * Converts a backend hashrate value in KSol/s to a scaled value with an appropriate unit prefix.
 * The minimum unit is KSol/s, then values are scaled up to MSol/s, GSol/s, etc.
 * while the magnitude remains >= 1000.
 */
export const numberToSolHashrate = (
  kSolValue: number | undefined,
  rule?: DecimalRuleDescription,
): ISolHashrateValue => {
  let hashRate: number | string = 0;
  let literal = `${UNITS[0]}${POSTFIX}`;

  if (kSolValue !== undefined && kSolValue > 0) {
    let numeric = kSolValue;

    for (const unit of UNITS) {
      literal = `${unit}${POSTFIX}`;
      if (numeric < 1000) {
        break;
      }
      numeric /= 1000;
    }

    hashRate = rule ? truncateDecimal(numeric, rule) : Number(numeric.toFixed(2));
  } else if (rule) {
    hashRate = '0';
  }

  return { hashRate, literal };
};
